const magdalenaData = {
  experience: [
    {
      iconName: "RiUserHeartLine",
      text: "Magdalena Pinedo, *Psicóloga Clínica y Psicoterapeuta*, con más de cinco años de experiencia atendiendo pacientes en consulta particular, desde el *Modelo de Psicoterapia Cognitivo - Posracionalista*.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "Experiencia académica como ayudante en el ámbito de la *psicología clínica* y la *psicoterapia*.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Supervisora clínica particular*, en modalidad individual y grupal, a estudiantes en práctica profesional de la Carrera de Psicología y psicólogos titulados, impartiendo formación teórico - práctica, y supervisando casos clínicos, desde el modelo de psicoterapia *Cognitivo - Posracionalista*.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Investigaciones científicas* en el área de psicología y creación de *artículos* de psicología clínica y psicoterapia.",
    },
    {
      iconName: "TbAward",
      text: "Membresía Colegio de Psicólogos de Chile A.G.",
    },
    {
      iconName: "TbAward",
      text: "Membresía Sociedad Chilena de Psicología Clínica y Psicoterapia (SCPC).",
    },
    { iconName: "RiUserFollowLine", text: "Empática y comprensiva." },
    {
      iconName: "RiUserFollowLine",
      text: "Dispuesta a escuchar, aceptar críticas constructivas y resolver en todo momento.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Comprometida y responsable con mi trabajo.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Cuento con habilidades de responsabilidad afectiva necesarias para el trabajo con pacientes.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Exenta de realización de juicios de valor en cualquier ámbito.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Dispuesta a entregar un espacio seguro y de confianza a mis pacientes en todo momento.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Magdalena, se ha realizado procesos de psicoterapia, desde hace aproximadamente 3 años, mantiéndose activa en la actualidad, con el fin de lograr un crecimiento en lo personal y profesional, debido a que considera importante el trabajo de *“la persona del terapeuta”*, lo cual influye directamente en mejores resultados en la práctica clínica al atender pacientes.",
    },
  ],
  studies: [
    {
      iconName: "FaGraduationCap",
      text: "*Licenciada en Psicología* y *Titulada de Psicóloga*, Universidad Autónoma de Chile, sede Providencia, Santiago de Chile *(Distinción Máxima).*",
    },
    {
      iconName: "FaGraduationCap",
      text: "Tesis de Licenciatura: *“Creación y Validación de un instrumento que evalúa la Normalización de la Violencia en Parejas Adolescentes”.*",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Práctica profesional* en Clínica de Atención Psicológica *(CAPS)*, sede Providencia.",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Diplomado de postítulo*en Psicología Jurídica: especialización en evaluación psicológica forense. *Pontificia Universidad Católica de Chile (PUC).*",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Cursos de psicoterapia* de formación en el área de psicología, posterior al titulo de psicóloga.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Workshop: *“La práctica clínica en la terapia posracionalista”. Doctor Juan Balbi.* Centro de Terapia Posracionalista (CETEPO, Chile).",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Supervisión continua de casos clínicos,* participación en reuniones clínicas, grupos de estudios y entrenamiento en el método de psicoterapia con el que trabaja.",
    },
    {
      iconName: "FaGraduationCap",
      text: "XXIII Congreso Nacional de Psicología Clínica: Temas emergentes en el SXXI. Organizado por la *Sociedad Chilena de Psicología Clínica (SCPC).* Realizado en la Universidad Autónoma de Chile, sede Providencia. (Santiago, Chile).",
    },
  ],
};

export default magdalenaData;
